module.exports = __webpack_public_path__ + "static/media/chuchai.914bbd0e.png";